import { useNavigate } from 'react-router-dom';

export default function WelcomePage() {
  const navigate = useNavigate();

  const handleContinue = () => {
    localStorage.setItem('has_seen_welcome', 'true');
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-[#F5F0E8] flex items-center justify-center p-8">
      <div className="max-w-lg text-center">
        <h1 className="text-4xl font-bold text-[#2C3E3D] mb-4">Welcome to Trailhead!</h1>
        <p className="text-lg text-[#3D5A5F] mb-8">
          Your marketing journey starts here. We'll guide you through each phase
          to build a complete marketing system for your business.
        </p>
        <button
          onClick={handleContinue}
          className="px-8 py-3 bg-[#C4754C] text-white rounded-lg font-semibold hover:bg-[#a8603d] transition-colors"
        >
          Get Started
        </button>
      </div>
    </div>
  );
}
